import $ from 'jquery'
import $PromoCodes from '../../common/promo-codes'
import Quote from './Quote'
import SelectedJobsState from './SelectedJobsState'

export default class BasketSummary {
  constructor() {
    this.basket = $('.js-basket');
    this.priceHeading = $('.v2-basket-summary-title');
    this.totals = this.basket.find('.totals');
    this.totalPrice = this.totals.find('.our-price').children('span');
    this.dealerPrice = this.totals.find('.dealer-price').children('span');
    this.savingPercentage = this.totals.find('.savings').children('span');
    this.promotion = this.totals.find('.promotion')
  }

  update(data) {
    this._updatePriceHeading(data);
    this._updateDealerPrice(data);
    this._updateTotalPrice(data);
    this._updateSavings(data);
    this._updatePromotionalSaving(data);
  }

  renderPromoDiscount(discount) {
    this.promotion.removeClass('hidden').find('.promo-price').text(discount);
  }

  _updatePriceHeading(data) {
    const quote = new Quote(data);
    this.priceHeading.text(quote.unquotedParts().length ? 'Partial price' : 'Total price');
  }

  _updateTotalPrice(data) {
    this.totalPrice.text(data['total_price']);
  }

  _updateDealerPrice(data) {
    const price = data['dealership_price'];
    if (price) {
      this.totals.find('.dealer, .dealer-price').removeClass('hidden');
      this.totals.find(this.dealerPrice).text(price).data('dealership-price', price);
      this.totals.find('.js-basket-dealer-price-label').text(new SelectedJobsState().ppiItemsOnly() ? 'The RAC price:' : 'Dealer price:');
    } else {
      this.totals.find('.dealer, .dealer-price').addClass('hidden');
    }
  }

  _updatePromotionalSaving(data) {
    if (data['promotional_saving']) {
      $PromoCodes.updateDynamicQuotePage(data);
    } else {
      this.promotion.addClass('hidden');
    }
  }

  _updateSavings(data) {
    const saving = data['saving']
    if (saving) {
      this.totals.find('.savings').removeClass('hidden');
      this.totals.find(this.savingPercentage).text(saving);
    } else {
      this.totals.find('.savings').addClass('hidden');
    }
  }
}
